import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { ScrollArea } from '@/components/ui/scroll-area';

interface MobileSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
  side?: 'left' | 'right' | 'top' | 'bottom';
}

export const MobileSheet: React.FC<MobileSheetProps> = ({
  open,
  onOpenChange,
  title,
  children,
  side = 'left',
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side={side} className="w-[85vw] max-w-sm p-0 flex flex-col">
        <SheetHeader className="px-3 sm:px-4 py-2 sm:py-3 border-b border-border shrink-0">
          <SheetTitle className="text-xs sm:text-sm">{title}</SheetTitle>
        </SheetHeader>
        <ScrollArea className="flex-1 min-h-0">
          {children}
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};
